import React from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Amplify } from 'aws-amplify';
import { SnackbarProvider } from 'notistack';

import './App.css';
import awsconfig from './config/awsConfig';
import ConfigProvider from './configProvider';
import { HomeComponent } from '&features/home/home.component';
import { WithNavBar } from '&route/withNavbar';
import Footer from './components/footer/footer.component';
import { ChallengesComponent } from '&features/challenges/challenges.component';
import { SubmitChallengeComponent } from '&features/submitChallenge/submitChallenge.component';
import SubmitMobile from './components/submitMobile/submitMobile.component';
import { ThemeDetailsComponent } from '&features/themeDetails/themeDetails.component';
import { ChallengeDetailsComponent } from '&features/challengeDetails/challengeDetails.component';
import FooterNav from './components/footerMenu/footerMenu.component';
import { AboutUsComponent } from '&features/aboutUs/aboutUs.component';
import { FAQComponent } from '&features/faq/faq.component';

const theme = createTheme({});

Amplify.configure(awsconfig);

const App = () => {
	const { i18n } = useTranslation();

	return (
		<ConfigProvider i18n={i18n}>
			<ThemeProvider theme={theme}>
				<SnackbarProvider
					anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
				>
					<BrowserRouter>
						<Routes>
							<Route element={<WithNavBar />}>
								<Route path="/" element={<HomeComponent />} />
								<Route
									path="/challenges/:type"
									element={<ChallengesComponent />}
								/>
								<Route
									path="/theme/:pk/:sk"
									element={<ThemeDetailsComponent />}
								/>
								{/* <Route
									path="/submit-challenge"
									element={<SubmitChallengeComponent />}
								/> */}
								<Route
									path="/challenge-details/:pk"
									element={<ChallengeDetailsComponent />}
								/>
								<Route path="/about-us" element={<AboutUsComponent />} />

								<Route path="/faq" element={<FAQComponent />} />
								<Route
									path="/404"
									element={
										<div
											style={{
												display: 'flex',
												justifyContent: 'center',
											}}
										>
											<h1>Page not found</h1>
										</div>
									}
								/>
								<Route path="*" element={<Navigate to="/404" />} />
							</Route>
						</Routes>
						<Footer />
						{/* <FooterNav /> */}
						{/* <SubmitMobile /> */}
					</BrowserRouter>
				</SnackbarProvider>
			</ThemeProvider>
		</ConfigProvider>
	);
};

export { App };
